document.addEventListener("DOMContentLoaded", function() {
  let buttons = document.querySelectorAll("#resources-filter .resource-btn");
  const contents = document.querySelectorAll(".resources-content");

  buttons.forEach(btn => {
    const target = btn.getAttribute("data-target");
    const targetContent = document.getElementById(target);

    if (!targetContent || targetContent.children.length === 0) {
      btn.remove(); 
    }
  });
  buttons = document.querySelectorAll("#resources-filter .resource-btn");
  if (buttons.length > 0) {
    buttons[0].classList.add("active", "button--primary");
    buttons[0].classList.remove("button--secondary");
    buttons[0].setAttribute("disabled", "true");
    const firstTarget = buttons[0].getAttribute("data-target");
    document.getElementById(firstTarget)?.classList.remove("hidden");
  }
  buttons.forEach(btn => {
    btn.addEventListener("click", function() {
      const target = this.getAttribute("data-target");
      buttons.forEach(b => {
        b.classList.remove("active", "button--primary");
        b.classList.add("button--secondary");
        b.removeAttribute("disabled");
      });
      this.classList.add("active", "button--primary");
      this.classList.remove("button--secondary");
      this.setAttribute("disabled", "true");

      contents.forEach(c => c.classList.add("hidden"));
      document.getElementById(target)?.classList.remove("hidden");
    });
  });
});

 function setEqualHeight(selector) {
    const elements = document.querySelectorAll(selector);
    let maxHeight = 0;

    // Reset any existing height
    elements.forEach(el => el.style.height = 'auto');

    // Find max height
    elements.forEach(el => {
      const height = el.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    // Apply max height
    elements.forEach(el => el.style.height = maxHeight + 'px');
  }
  $(window).on("load", function() {
    $.fn.lightspeedBox();
});
$('.resources-content').each(function() {
  const slider = $(this);
  const itemCount = slider.children('.resource-item').length;
  const slidesToShow = 3.5;

    slider.slick({
      slidesToShow: 3.5,
      slidesToScroll: 1,
      dots: itemCount > slidesToShow,
      customPaging: function(slider, i) {
        return '<button type="button" class="flickity-page-dot" aria-label="View slide ' + (i + 1) + '"></button>';
      },
      arrows: false,
      infinite: false,
      adaptiveHeight: true,
      prevArrow: '<button class="prev_arrow_slick button button--secondary pointer-events-auto" type="button" is="previous-button" aria-controls="SliderGallery-template--25622779494681__5a2a4051-042d-48d7-955c-dc7a08cd5474-8678367428889" aria-label="Previous"><span class="btn-fill" data-fill="" style="transform: translateY(var(--motion-translateY)); --motion-translateY: -76%;"></span><span class="btn-text"><svg class="icon icon-chevron-left icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M14 6L8 12L14 18"></path></svg></span><span class="btn-loader"><span></span><span></span><span></span></span></button>',
      nextArrow: '<button class="next_arrow_slick button button--secondary pointer-events-auto" type="button" is="next-button" aria-controls="SliderGallery-template--25622779494681__5a2a4051-042d-48d7-955c-dc7a08cd5474-8678367428889" aria-label="Next"><span class="btn-fill" data-fill="" style="transform: translateY(var(--motion-translateY)); --motion-translateY: -76%;"></span><span class="btn-text"><svg class="icon icon-chevron-right icon-md transform" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M10 6L16 12L10 18"></path>    </svg></span><span class="btn-loader"><span></span><span></span><span></span></span></button>',
      responsive: [
        {
            breakpoint: 800,
            settings: {
            slidesToShow: 2.5,
          }
        },
         {
            breakpoint: 600,
            settings: {
            slidesToShow: 1.5,
          }
        },
      ]
    });
});
   window.addEventListener('DOMContentLoaded', () => setEqualHeight('#resource-resource_tab_z93WPG .resource-item .helpuful_image img '));
      window.addEventListener('resize', () => setEqualHeight('#resource-resource_tab_z93WPG .resource-item .helpuful_image img'));
      window.addEventListener('DOMContentLoaded', () => setEqualHeight('#resource-resource_tab_8FK94k .resource-item .helpuful_image img'));
      window.addEventListener('resize', () => setEqualHeight('#resource-resource_tab_8FK94k .resource-item .helpuful_image img'));
     window.addEventListener('DOMContentLoaded', () => setEqualHeight('#resource-resource_tab_z93WPG .resource-item .field_description '));
      window.addEventListener('resize', () => setEqualHeight('#resource-resource_tab_z93WPG .resource-item .field_description'));
      window.addEventListener('DOMContentLoaded', () => setEqualHeight('#resource-resource_tab_prkwt8 .resource-item'));
      window.addEventListener('resize', () => setEqualHeight('#resource-resource_tab_prkwt8 .resource-item '));
      window.addEventListener('DOMContentLoaded', () => setEqualHeight('#resource-resource_tab_8FK94k .resource-item .field_description'));
      window.addEventListener('resize', () => setEqualHeight('#resource-resource_tab_8FK94k .resource-item .field_description'));
